import { createAction, createEmptyAction, createMapAction } from "chalet-shared";

import { RoomView } from "../reducers/rooms";
import { RosterView, SettingsView } from "../reducers/roster";

export type UsersSearchByNamePayload = {
    roomView: RoomView;
    value: string;
    limitToMentionableUsers?: true;
};

export type UsersSearchByIdsPayload = {
    roomView: RoomView;
    userIds: string[];
};

export const actionCreators = {
    getRoster: createEmptyAction("GET_ROSTER"),
    getRosterFailed: createEmptyAction("GET_ROSTER_FAILED"),
    ensureRosterForRoom: createMapAction("ENSURE_ROSTER_FOR_ROOM", (roomId: string) => roomId),
    ensureRosterForRoomFailed: createMapAction(
        "ENSURE_ROSTER_FOR_ROOM_FAILED",
        (roomId: string) => roomId
    ),
    performUsersSearchByName: createMapAction(
        "PERFORM_USERS_SEARCH_BY_NAME",
        (x: UsersSearchByNamePayload) => x
    ),
    performUsersSearchByNameFailed: createMapAction(
        "PERFORM_USERS_SEARCH_BY_NAME_FAILED",
        (x: UsersSearchByNamePayload) => x
    ),
    performUsersSearchByIds: createMapAction(
        "PERFORM_USERS_SEARCH_BY_IDS",
        (x: UsersSearchByIdsPayload) => x
    ),
    performUsersSearchByIdsFailed: createMapAction(
        "PERFORM_USERS_SEARCH_BY_IDS_FAILED",
        (x: UsersSearchByIdsPayload) => x
    ),
    ensureMembersForPrivateRoom: createMapAction(
        "ENSURE_MEMBERS_FOR_PRIVATE_ROOM",
        (x: { roomView: RoomView }) => x
    ),
    selectRosterView: createMapAction("SELECT_ROSTER_VIEW", (x: { elementId: RosterView }) => x),
    selectSettingsView: createAction("SELECT_SETTINGS_VIEW", (viewId: SettingsView) => ({
        type: "SELECT_SETTINGS_VIEW",
        payload: { viewId },
    })),
};
